export const UPDATE_UI_STORE = "UPDATE_UI_STORE";

export const COMMON_DATE_FORMAT = "MMM dd, yyyy";
export const COMMON_DATE_TIME_FORMAT = "MMM dd, yyyy@HH:mm";
export const YYYY_MM_DD_FORMAT = "yyyy/MM/dd HH:mm:ss";
export const FULL_DATE_TIME_FORMAT = "MMMM dd, yyyy@HH:mm";
export const FIRST_DAY_OF_YEAR_DATE = new Date(new Date().getFullYear(), 0, 1);

export const ADD_OVERLAY_FILTER = "ADD_OVERLAY_FILTER";
export const REMOVE_OVERLAY_FILTER = "REMOVE_OVERLAY_FILTER";
export const REMOVE_ALL_OVERLAY_FILTER_BY_ID = "REMOVE_ALL_OVERLAY_FILTER_BY_ID";
